'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');
var getThemeProp = require('../../utils/getThemeProp.js');
var Button = _interopDefault(require('@material-ui/core/Button'));
var styles = require('@material-ui/core/styles');
var highlight = require('../utils/highlight.js');

var StyledButton = styled__default(Button)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  ", "\n  border-radius: 6px;\n  position: relative;\n  background-color: ", ";\n  font-size: 14px;\n  max-width: 100%;\n  text-transform: none;\n  height: 35px;\n\n  &.Mui-disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  .disabled {\n    color: #6e84a3;\n  }\n"], ["\n  ", "\n  border-radius: 6px;\n  position: relative;\n  background-color: ", ";\n  font-size: 14px;\n  max-width: 100%;\n  text-transform: none;\n  height: 35px;\n\n  &.Mui-disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  .disabled {\n    color: #6e84a3;\n  }\n"])), highlight.input, getThemeProp('palette.background.paper', 'rgba(0,0,0,1)'), getThemeProp('palette.action.disabled', 'rgba(0,0,0,1)'), getThemeProp('palette.text.primary', 'rgba(0,0,0,1)'));
var Main = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  .MuiInputBase-root {\n    width: 100%;\n  }\n"], ["\n  .MuiInputBase-root {\n    width: 100%;\n  }\n"])));
var StyledMenu = styled__default(core.Menu)(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject([""], [""])));
var StyledMenuItem = styled__default(core.MenuItem)(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  padding-top: 0;\n  padding-bottom: 0;\n"], ["\n  padding-top: 0;\n  padding-bottom: 0;\n"])));
var StyledResetMenuItem = styled__default(core.MenuItem)(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n  border-top: 1px solid ", ";\n"], ["\n  border-top: 1px solid ", ";\n"])), getThemeProp('palette.border.main', '#d4dbe4'));
var useStyles = styles.makeStyles({
    popoverPaper: {
        minWidth: '200px',
    },
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.Main = Main;
exports.StyledButton = StyledButton;
exports.StyledMenu = StyledMenu;
exports.StyledMenuItem = StyledMenuItem;
exports.StyledResetMenuItem = StyledResetMenuItem;
exports.useStyles = useStyles;
